import React, { useEffect, useState } from "react";
import { Button, Form, Input, message } from "antd";
import { history } from "../appRedux/store";
import { connect } from "react-redux";
import { sendUserOtpAPI, verifyAuthOtp } from "../services/users-service";
import { updateOtpVerificationStatus } from "../appRedux/actions";
import moment from "moment";

const totalSeconds = 60;
const FormItem = Form.Item;

function VerifyEmailOtp(props) {
    const { authUser, form } = props;
    const { getFieldDecorator } = form;

    const [loading, setLoading] = useState(true);
    const [disabled, setDisabled] = useState(true);
    const [seconds, setSeconds] = useState(totalSeconds);

    useEffect(() => {
        async function handleSendCode() {
            try {
                setLoading(true);
                const response = await sendUserOtpAPI({
                    email: authUser.email,
                    mode: "EMAIL",
                    userId: authUser.userId
                });
                if (!response.success)
                    throw new Error("Error in sending OTP, please try again!");

                message.success("OTP sent successfully!");
            } catch (error) {
                message.error(
                    error.message || "Something went wrong, please try again!"
                );
            } finally {
                setLoading(false);
            }
        }
        handleSendCode();
    }, []);

    useEffect(() => {
        if (!authUser) {
            history.push("/signin");
        }
        if (authUser && authUser.otpVerified) {
            history.push("/");
        }
    }, [authUser]);

    useEffect(() => {
        if (
            authUser &&
            !authUser.otpVerified
        ) {
            const counter = setInterval(() => {
                if (seconds > 0) {
                    setSeconds(seconds - 1);
                } else {
                    clearInterval(counter);
                    setDisabled(false);
                }
            }, 1000);
            return () => {
                clearInterval(counter);
            };
        }
    }, [authUser, seconds]);

    const handleSubmit = (e) => {
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                const data = {
                    email: authUser.email,
                    code: values.code,
                    mode: "EMAIL",
                };
                try {
                    setLoading(true);
                    const response = await verifyAuthOtp(data);
                    if (response.success) {
                        message.success("OTP verified successfully");
                        props.updateOtpVerificationStatus();
                        history.push("/");
                    } else {
                        throw new Error("Invalid code, please try again");
                    }
                } catch (error) {
                    message.error("Invalid code, please try again");
                    console.log("Error verifying OTP: ", error);
                }
                finally {
                    setLoading(false);
                }
            }
        });
    };

    const resendOtp = async () => {
        const response = await sendUserOtpAPI({
            email: authUser.email,
            mode: "EMAIL",
            userId: authUser.userId
        });
        if (response.success) {
            setSeconds(totalSeconds);
            setDisabled(true);
            message.success("OTP sent successfully!");
        } else {
            message.error("Failed to send OTP.");
        }
    };

    return (
        <div className="gx-app-login-wrap">
            <div className="verify-container">
                <div>
                    <h1 className="authenticator-heading">
                        Enter the 6-digit Code from the Email
                    </h1>
                </div>
                <div className="verify-container-block">
                    <div className="gx-app-login-content">
                        <Form
                            initialValues={{ remember: false }}
                            name="basic"
                            onSubmit={handleSubmit}
                            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
                        >
                            <FormItem label={<span className="label-otp">Enter Code</span>} style={{ margin: '0px -5px 0px' }}>
                                {getFieldDecorator("code", {
                                    initialValue: "",
                                    rules: [
                                        {
                                            required: true,
                                            message: "Please input OTP!!",
                                            whitespace: false,
                                            len: 6,
                                        },
                                    ],
                                })(<Input type="number" maxLength={6} />)}
                            </FormItem>
                            <p style={{ textAlign: "center", fontWeight: 300, color: '#E5E5E5' }}>
                                Didn't receive the OTP?{" "}
                                {authUser && (
                                    <Button
                                        className={"resend-btn-link"}
                                        loading={loading}
                                        disabled={disabled}
                                        onClick={resendOtp}
                                    >
                                        Resend OTP
                                    </Button>
                                )}
                                {authUser && (
                                    <p style={{ marginTop: "10px", marginBottom: "0px" }}>
                                        Resent OTP in &nbsp;
                                        <span style={{ color: "#82C9D7" }}>
                                            {moment.utc(seconds * 1000).format("mm:ss")}
                                        </span>
                                    </p>
                                )}
                            </p>
                            <p style={{ textAlign: "center", fontWeight: 400, padding: '0 15px', color: "#fff" }}>
                                We've sent a 6-digit verification code to your registered email. Please enter it to continue.
                            </p>

                            <Button
                                block
                                type="primary"
                                loading={loading}
                                htmlType="submit"
                                style={{ minHeight: '45px' }}
                            >
                                {"Verify"}
                            </Button>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    )

}

const VerifyEmailOtpCode = Form.create()(VerifyEmailOtp);

const mapStateToProps = ({ auth }) => {
    const { authUser } = auth;
    return { authUser }
};

export const mapDispatchToProps = dispatch => ({
    updateOtpVerificationStatus: (isAuthenticator) => dispatch(updateOtpVerificationStatus(isAuthenticator))
});


export default connect(mapStateToProps, mapDispatchToProps)(VerifyEmailOtpCode);